import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getNCRById, updateNCR } from "../../../services/api/qa/ncrService";
import toast from "react-hot-toast";

function EditNCR() {

  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadNCR();
  }, []);

  const loadNCR = async () => {
    try {
      const res = await getNCRById(id);
      setFormData(res.data);
    } catch {
      toast.error("Failed to load NCR");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await updateNCR(id, formData);
      toast.success("NCR Updated Successfully");
      navigate(`/ncr/${id}`);
    } catch {
      toast.error("Update Failed");
    }
  };

  if (loading)
    return (
      <div className="p-10 text-center">
        <div className="animate-spin h-8 w-8 border-4 border-blue-500 border-t-transparent rounded-full mx-auto"></div>
        <p className="mt-2 text-gray-500">Loading NCR...</p>
      </div>
    );

  return (
    <div className="max-w-4xl mx-auto bg-white p-6 shadow rounded">

      <h2 className="text-2xl font-bold mb-6">Edit NCR</h2>

      <form onSubmit={handleSubmit} className="space-y-4">

        {/* Title */}
        <div>
          <label className="block font-medium mb-1">Title</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="w-full border p-2 rounded"
          />
        </div>

        {/* Description */}
        <div>
          <label className="block font-medium mb-1">Issue Description</label>
          <textarea
            name="issue_description"
            value={formData.issue_description}
            onChange={handleChange}
            className="w-full border p-2 rounded"
            rows="4"
          />
        </div>

        {/* Severity */}
        <div>
          <label className="block font-medium mb-1">Severity</label>
          <select
            name="severity"
            value={formData.severity}
            onChange={handleChange}
            className="w-full border p-2 rounded"
          >
            <option value="low">Low</option>
            <option value="medium">Medium</option>
            <option value="high">High</option>
            <option value="critical">Critical</option>
          </select>
        </div>

        {/* Due Date */}
        <div>
          <label className="block font-medium mb-1">Due Date</label>
          <input
            type="date"
            name="due_date"
            value={formData.due_date || ""}
            onChange={handleChange}
            className="w-full border p-2 rounded"
          />
        </div>

        {/* Corrective Action */}
        <div>
          <label className="block font-medium mb-1">Corrective Action</label>
          <textarea
            name="corrective_action"
            value={formData.corrective_action || ""}
            onChange={handleChange}
            className="w-full border p-2 rounded"
            rows="3"
          />
        </div>

        {/* Read Only Fields */}
        <div className="bg-gray-100 p-4 rounded mt-4">
          <h3 className="font-semibold mb-2">Reference Info</h3>

          <p><strong>Project:</strong> {formData.project?.project_name}</p>

          <p><strong>BOQ Item:</strong> {formData.boq_item?.item_name}</p>

          <p><strong>Reported By:</strong> {formData.reported_by}</p>

          <p><strong>Created At:</strong> {formData.created_at}</p>
        </div>

        {/* Buttons */}
        <div className="flex justify-end gap-3">

          <button
            type="button"
            onClick={() => navigate(`/ncr/${id}`)}
            className="border px-4 py-2 rounded"
          >
            Cancel
          </button>

          <button
            type="submit"
            className="bg-blue-600 text-white px-4 py-2 rounded"
          >
            Update NCR
          </button>

        </div>

      </form>

    </div>
  );
}

export default EditNCR;